// @ts-check
import { head, prop } from 'ramda'
import { ErrorConstants } from '../../../shared/errorConstants'
import { fetchAddressOptions } from '../address'
import {
  BACKGROUND_CHECK_VALUES,
  DRUG_SCREEN_VALUES,
  SCREENING
} from '../../../component-templates/certification-badge/constants'
import { getSplitAttributes } from '../../../shared/split'

const DEFAULT_COMPANY_INFO = {
  markup: 25,
  vmarkup: null,
  vmarkupOt: null,
  vmarkupDt: null,
  vmarkupHosted: null,
  vmarkupHostedOt: null,
  vmarkupHostedDt: null,
  net_pay: 7,
  pricing_type: 1,
  beta_active: 1,
  refill_on: 0,
  source: 8,
  can_post: 0,
  signed_contract: 0,
  background_check_required: 0,
  drug_screen_required: 0,
}

export class CreateCompanyController {
  /* @ngInject */
  constructor (Companies, companies, Auth, $rootScope, $mdToast, $scope, $q, $window, regions) {
    this.$q = $q
    this.$window = $window
    this.$rootScope = $rootScope
    this.Companies = Companies
    this.Auth = Auth
    this.$mdToast = $mdToast
    this.$scope = $scope
    $scope.logoURL = ''
    this.regions = regions
    $scope.imageUpload = (elem) => {
      const reader = new FileReader()
      reader.onload = $scope.imageIsLoaded
      reader.readAsDataURL(elem.files[0])
    }

    $scope.imageIsLoaded = (e) => {
      $scope.logoURL = e.target.result
      this.editPhoto = false
      $scope.$apply()
    }
    this.editPhoto = true
    this.myCroppedImage = ''

    this.searchText = ''
    this.companyInfo = DEFAULT_COMPANY_INFO
    if (Auth.me && (Auth.me.accountType === 'ADMIN' || Auth.me.accountType === 'PAYROLL_ADMIN' || Auth.me.accountType === 'SUPER_ADMIN')) {
      this.companyInfo.can_post = 1
      this.Companies.fetchAdmins()
        .then((admins) => { this.accountManagers = admins })
    }
    this.selectedPlace = ''
    this.showHosted = false
    this.pricingType = this.companyInfo.pricing_type;

    // all companies to be used in parent company selection
    this.companiesList = companies.companies
    this.SCREENING = SCREENING
    this.Auth.splitClient.ready().then(() =>  {
      // Company attributes do not exist because we are creating a new company.
      const attributes = { ...getSplitAttributes(this.Auth), company_id: undefined, company_name: undefined };
      this.drug_screening_p0_enabled = this.Auth.splitClient.getTreatment("drug_screening_p0", attributes) === "on"
      this.advanced_background_check_p0_enabled = this.Auth.splitClient.getTreatment("advanced_background_check_p0", attributes) === "on"
    })
    this.screeningFieldDropdownState = {
      backgroundCheck: false,
      drugScreen: false,
    }

    this.$scope.$watch('new.screeningFieldDropdownState.drugScreen', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.onDrugScreenToggle(newValue);
      }
    });

    this.$scope.$watch('new.screeningFieldDropdownState.backgroundCheck', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.onBackgroundCheckToggle(newValue);
      }
    });
  }

  onHostedMarkup(active) {
    this.showHosted=active;
  }

  /**
   * @param settingRequiredKey {string} - the name of the setting to check.
   * 'settingRequiredKey' is either 'drug_screen_required' or 'background_check_required'.
   * ng-model sets values as a string for 'safety'. So even if our key-value types are correct, they'll be strings which
   * isn't right. Need to explicitly convert to an integer (number).
   *
   */
  checkScreeningFieldSelection(settingRequiredKey) {
    this.companyInfo[settingRequiredKey] = parseInt(this.companyInfo[settingRequiredKey])
  }

  /**
   * @param {boolean} dropdownIsOpen - state of the drug screening dropdown.
   */
  onDrugScreenToggle(dropdownIsOpen) {
    if (dropdownIsOpen) {
      this.companyInfo.drug_screen_required = DRUG_SCREEN_VALUES.FIVE_PANEL_NO_THC;
    } else {
      this.companyInfo.drug_screen_required = DRUG_SCREEN_VALUES.NOT_ENABLED;
    }
  }

  /**
   * @param {boolean} dropdownIsOpen - state of the background check dropdown.
   */
  onBackgroundCheckToggle(dropdownIsOpen) {
    if (dropdownIsOpen) {
      this.companyInfo.background_check_required = BACKGROUND_CHECK_VALUES.BASIC_CRIMINAL_WITH_THREE_ALIASES;
    } else {
      this.companyInfo.background_check_required = BACKGROUND_CHECK_VALUES.NOT_ENABLED;
    }
  }

  createCompany () {
    if (this.createCompanyForm.$invalid) {
      return
    }
    if (this.myCroppedImage === '') {
      this.$mdToast.showSimple('Oops, load a company logo')
      return
    }
    this.$rootScope.$broadcast('app:loading:start')
    var data = this.myCroppedImage.substring(this.myCroppedImage.indexOf(',') + 1)
    this.Companies.uploadLogo({
      logo_base64: data
    })
    .then((res) => {
      this.companyInfo.logo_id = res.id
      this.newCompany()
    })
    .catch((err) => {
      this.$rootScope.$broadcast('app:loading:done')
      if (!err) return
      this.$mdToast.showSimple('Failed To Upload Logo')
    })
  }

  newCompany () {
    this.companyInfo.hubspot_id = this.companyInfo.hubspot_id !== '' ? this.companyInfo.hubspot_id : null
    this.companyInfo.business_unit = this.companyInfo.business_unit !== '' ? this.companyInfo.business_unit : null
    this.companyInfo.product_code = this.companyInfo.product_code !== '' ? this.companyInfo.product_code : null

    this.companyInfo.pricing_type = this.pricingType;

    if ((!this.showHosted) || (this.companyInfo.pricing_type != 8)) {
      this.companyInfo.vmarkupHosted = 0
      this.companyInfo.vmarkupHostedDt = 0
      this.companyInfo.vmarkupHostedOt = 0
    }
    if (this.companyInfo.pricing_type != 8) {
      this.companyInfo.vmarkup = 0
      this.companyInfo.vmarkupDt = 0
      this.companyInfo.vmarkupOt = 0
    }
    else {
      this.companyInfo.pricing_type = 0;
      this.companyInfo.markup = this.companyInfo.vmarkup;
    }
    this.Companies.createCompany({
      companyInfo: this.companyInfo
    })
      .then(() => {
        this.$mdToast.showSimple('Successfully Created Company')
        this.Auth.me = {}
        this.Companies.getCompanyData()
        this.$window.location.href = `${this.$scope.$parent.app.reactAppUrl}/jobs/post`
      })
      .catch((err) => {
        this.$rootScope.$broadcast('app:loading:done')
        if (!err) return
        if (err?.data?.reason === ErrorConstants.INVALID_PHONE_NUMBER) {
          this.$mdToast.showSimple('Failed To Create Company: Invalid Phone Number')
        } else {
          this.$mdToast.showSimple('Failed To Create Company')
        }
      })
  }

  queryAddress(input) {
    const def = this.$q.defer();
    this.AutocompleteService =
      new this.$window.google.maps.places.AutocompleteService();
    this.PlacesService = new this.$window.google.maps.places.PlacesService(
      document.getElementById("places-div")
    );

    fetchAddressOptions(input, def, this.AutocompleteService, this.PlacesService)

    return def.promise;
  }

  handleSelectAddress() {
    const def = this.$q.defer();
    if (!this.selectedPlace) {
      this.createCompanyForm.address.$error['md-require-match'] = true;
      this.createCompanyForm.invalid = true;
      return def.resolve()
    } else {
      this.createCompanyForm.address.$error = {};
      this.createCompanyForm.address.$invalid = false;
      this.createCompanyForm.invalid = false;
    }

    let streetNumber;
    let streetName;
    let _country; // Unused

    this.selectedPlace.address_components.forEach((x) => {
      var type = head(prop("types", x));
      if (type === "street_number") streetNumber = x.long_name;
      if (type === "route") streetName = x.long_name;
      if (type === "locality") this.companyInfo.city = x.long_name;
      if (type === "country") _country = x.long_name;
      if (type === "administrative_area_level_1")
        this.companyInfo.state = x.short_name;
      if (type === "administrative_area_level_2")
        this.companyInfo.county = x.long_name;
      if (type === "street_number")
        this.companyInfo.street_number = x.long_name;
      if (type === "postal_code") this.companyInfo.zipcode = x.long_name;
    });

    if (!streetNumber || !this.companyInfo.zipcode) {
      this.createCompanyForm.address.$error['md-invalid-address'] = true;
      this.createCompanyForm.invalid = true;
      return def.resolve();
    }

    this.companyInfo.address = `${streetNumber} ${streetName}`;
    this.companyInfo.address_latitude =
      this.selectedPlace.geometry.location.lat();
    this.companyInfo.address_longitude =
      this.selectedPlace.geometry.location.lng();
    this.createCompanyForm.address.$error = {}
    this.createCompanyForm.address.$invalid = false
    this.createCompanyForm.invalid = false
    return def.resolve();
  }

  onRegionChange (regionId) {
    const selectedRegion = this.regions.find(r => r.id === regionId)

    if (selectedRegion && selectedRegion.default_business_unit) {
      this.companyInfo.business_unit = selectedRegion.default_business_unit
    }
  }
}
